import React, { Component } from "react"
import { propertyStore } from "../ContextProviders"

class ValueStore extends Component {
    state = {
        add: (id, value) => {
            this.setState(values => ({ ...values, [id]: value }))
        },
        get: id => {
            return this.state[id]
        },
    }

    render() {
        return <propertyStore.Provider value={this.state} children={this.props.children} />
    }
}

ValueStore.propTypes = {}

export default ValueStore



// WEBPACK FOOTER //
// ./src/features/editor/properties/ValueStore.js